export default __webpack_public_path__ + "static/media/116-BU-BV-420.bd207816.png";